<div class="upload" [ngStyle]="{'cursor': isButtonDisabled() ? 'not-allowed' : 'pointer'}">
  <button [disabled]="isButtonDisabled()"
    mat-button
    type="button"
    id="upload-contract"
    (click)="this.openDialog()"
    matTooltip="{{tooltipMessage}}"
    matTooltipPosition="above">
    <span class="icon-upload">
      <mat-icon>file_upload</mat-icon>
    </span>
    <span class="button-text">{{ getTranslation(buttonText) }}</span>
    <span class="required" *ngIf="required && !['SGP', 'IDN'].includes(getUserCountry())">*</span>
  </button>
</div>